import React from 'react'

export type ToastContextValue = {
    triggerToast: (params: { severity?: string; summary?: string; detail?: string; life?: number }) => void
}

const defaultTriggerToast = () => {}

const ToastContext = React.createContext<ToastContextValue>({
    triggerToast: defaultTriggerToast,
})

export default ToastContext
